import clsx from 'clsx';
import React from 'react';

import media from 'styles/media.module.scss';
import styled from 'types/AppTheme';

import styles from './Table.module.scss';

export interface ITableProps {
  rows?: number;
  columns?: number;
  data: Array<{
    label: string;
    value: string;
    labelFontWeight?: 'bold' | 'normal';
    valueFontWeight?: 'bold' | 'normal';
    capitalizeValue?: boolean;
    capitalizeLabel?: boolean;
  }>;
  additionalKey?: string;
  wrapperClassName?: string;
}

const TableWrapper = styled.div<Omit<ITableProps, 'data'>>`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ columns }) => (columns ? `repeat(${columns}, 1fr)` : 'auto')};
  grid-template-rows: ${({ rows }) => {
    return rows ? `repeat(${rows}, 1fr)` : 'auto';
  }};
  column-gap: 30px;

  @media (max-width: ${media.maxMobile}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 14px 10px;
  border-top: 1px solid #e7e9ec;

  column-gap: 20px;
`;

const Table = ({ data, columns = 2, rows, wrapperClassName, additionalKey }: ITableProps) => {
  return (
    <TableWrapper columns={columns} rows={rows} className={wrapperClassName}>
      {data.map(
        ({ label, value, valueFontWeight, labelFontWeight, capitalizeValue, capitalizeLabel }) => {
          const labelClassName = clsx(
            styles.tableLabel,
            labelFontWeight === 'bold' && styles.tableValueBold,
            capitalizeLabel && styles.capitalize,
          );

          const valueClassName = clsx(
            styles.tableValue,
            valueFontWeight === 'bold' && styles.tableValueBold,
            capitalizeValue && styles.capitalize,
          );

          return (
            <TableRow key={label + value + additionalKey}>
              <p className={labelClassName}>{label}</p>
              <p className={valueClassName}>{value}</p>
            </TableRow>
          );
        },
      )}
    </TableWrapper>
  );
};

export default Table;
